var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Cleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "M40.002,41.969L8.033,42c-1.1,0.001-2.001-0.898-2.002-1.998L6.004,12.033 c-0.003-3.3,2.694-6.003,5.994-6.006L39.967,6c1.1-0.001,2.001,0.898,2.002,1.998L42,39.967L40.002,41.969z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M36.094,18.561L23.533,6H8C6.895,6,6,6.895,6,8v15.533l12.561,12.561L36.094,18.561z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M35.396,17.856l-4.252-4.252c-0.806-0.806-2.112-0.806-2.918,0L13.604,28.225 c-0.806,0.806-0.806,2.112,0,2.918l4.252,4.252c0.806,0.806,2.112,0.806,2.918,0l14.621-14.621 C36.201,19.969,36.201,18.662,35.396,17.856z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M37.396,19.856l-5.711-5.711l-17.54,17.54l5.711,5.711c0.806,0.806,2.112,0.806,2.918,0 l14.621-14.621C38.201,21.969,38.201,20.662,37.396,19.856z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M21.37,31.374l-0.961-0.961c-0.551-0.551-1.445-0.551-1.996,0s-0.551,1.445,0,1.996l0.961,0.961 c0.551,0.551,1.445,0.551,1.996,0l0,0C21.921,32.819,21.921,31.925,21.37,31.374z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M22.704,34.119l-0.585,0.585c-0.391,0.391-1.024,0.391-1.414,0l-1.41-1.41l1.999-1.999l1.41,1.41 C23.095,33.095,23.095,33.729,22.704,34.119z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M27.291,30.435L38.826,41.97l1.176-0.001c1.1-0.001,1.999-0.902,1.998-2.002l-0.001-1.113 L30.436,27.291L27.291,30.435z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M32.406,26.957c0,0-5.851-4.455-7.878-2.428s2.428,7.878,2.428,7.878 c0.791,0.791,2.074,0.791,2.866,0l2.584-2.584C33.198,29.031,33.198,27.748,32.406,26.957z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Cleaning);
export default __webpack_public_path__ + "static/media/icons8-cleaning.88124762b47bd512e3b7d5f2e802e692.svg";
export { ForwardRef as ReactComponent };